<template>
  <DBox
    :id="'cmp-catalog-products-tracklisting'"
    :addButton="false"
    :addLink="true"
    :addLinkLabel="$t('add_new') +' '+ $t('track-s')"
    :rightMenu="[
      {
        text: $t('copy_track_from_catno'),
        value: 'copy_track',
      },
      {
        text: $t('update_playtime'),
        value: 'update_playtime',
      },
    ]"
    @menuClick="onRightMenuClick"
    @addClick="addTrack"
  >
    <div class="ut-fh">
      <NTable
        class="dbox1"
        :headers="headers"
        :items="list"
        :config="tableConfig"
        :id="'accounting-invoices-invoice_line'"
        height="170px"
      >
        <template v-slot:item="{ item, tdcon }">
          <tr>
            <td v-bind="tdcon('media')">
              <TextField2
                id="set_no"
                class="dbox1"
                :ta="'right'"
                :showLabel="false"
                :value="item['set_no']"
                placeholder="0.00"
                @blur="(e) => onTextInputBlur(e, 'set_no', item)"
              />
            </td>
            <td v-if="!isDigital" v-bind="tdcon('side')">
              <TextField2
                id="side"
                class="dbox1"
                :ta="'right'"
                :showLabel="false"
                :value="item['side']"
                placeholder=""
                @blur="(e) => onTextInputBlur(e, 'side', item)"
              />
            </td>
            <td v-bind="tdcon('no')">
              <TextField2
                id="seq_no"
                class="dbox1"
                :ta="'right'"
                :showLabel="false"
                :value="item['seq_no']"
                placeholder="0.00"
                @blur="(e) => onTextInputBlur(e, 'seq_no', item)"
              />
            </td>
            <td v-bind="tdcon('artist')">
              <span class="ut-link ut-text-accent5">{{ item["artist"] }}</span>
            </td>
            <td
              :title="getConcatTitle(item)"
              class="txtov"
              v-bind="tdcon('title_column')"
            >
              <span
                @click="onTrackClick(item)"
                class="txtov ut-link ut-text-accent5"
              >
                {{ getConcatTitle(item) }}
              </span>
            </td>
            <td v-bind="tdcon('isrc')">
              <template v-if="item['display_wand_icon']==1||item['display_wand_icon']=='1'">
                <div class="ut-flex">
                  <div style="flex: 1;">
                    <span>{{ item["isrc"] }}</span>
                  </div>
                  <div class="dt-icon-container">
                    <img
                     
                      src="static/icons/edit-blue.svg"
                      class="dt-icon v5 s1"
                      :alt="$t('options')"
                      :title="$t('options')"
                    />
                  </div>
                </div>


              </template>
              <template v-else>
                <span>{{ item["isrc"] }}</span>
              </template>
              
            </td>
            <td v-bind="tdcon('digital_rights')">
                <Dropdown2
                    class="dbox1"
                    :showLabel="false"
                
                    :options="rightsTV"
                    :placeholder="$t('digital_rights')"
                    :selected="rightsTV.find(v => v.value == item.digital_right_type)"
                    v-on:selectedChange="e => onDropDownChange('digital_right_type', e, item)"
                    :bb="'0px'"
                >
                </Dropdown2>
            </td>
            <td v-bind="tdcon('bonus')">
              <div class="ut-rowcen">
                <div class="dt-checkbox v2 s1">
                  <input
                    type="checkbox"
                    :name="`exclude-${item['bonus_track_flag']}`"
                    :id="`exclude-${item['product_account_id']}`"
                    :checked="item['bonus_track_flag'] == '1'"
                    @click="(e) => onProductExclude(e, item)"
                  />
                  <div class="checkmark"></div>
                </div>
              </div>
            </td>
            <td :title="item['licensor']" v-bind="tdcon('licensor')">
              <span class="txtov"> {{ item["licensor"] }} </span>
            </td>
            <td v-bind="tdcon('time')">
              <TextField2
                id="playtime"
                class="dbox1"
                :showLabel="false"
                :value="item['playtime']"
                placeholder="0.00"
                @blur="(e) => onTextInputBlur(e, 'playtime', item)"
                ta="right"
              />
            </td>
            <td v-bind="tdcon('duplicate')">
              <div class="dt-icon-container">
                <img
                  style="color: #000"
                  src="static/icons/double-plus.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDuplicateTrack(item)"
                  :alt="$t('duplicate')"
                  :title="$t('duplicate')"
                />
              </div>
            </td>
            <td v-bind="tdcon('options')">
              <div class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  @click="(e) => onDeleteTrack(item)"
                  :alt="$t('options')"
                  :title="$t('options')"
                />
              </div>
            </td>
          </tr>
        </template>
      </NTable>
    </div>
  </DBox>
</template>

<script>
import { openMailWindow } from "@/utility";
import DBox from "@dtplugins/dbox/dbox";
import NTable from "@/plugins/datatable/datatable";
import TextField from "@plugins/text-field/text-field";

import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { tracksListLDTRoutes } from "../../router/routes";

export default {
  components: {
    TextField,
    NTable,
    DBox,
  },
  props: {
    selectedProductDetails: {
      required: true,
    },
  },
  data: function () {
    return {
      tableConfig: createNTableConfig({
        headerStyle: 3,
        fullHeight: true,
      }),
    };
  },
  computed: {
    rightsTV:function(){
      return [
          { text:"Full Rights",value:"1" },
          { text:"Bundle Only",value:"2" },
          { text:"No Digital Rights",value:"3" },
      ]
    },

    isDigital() {
      return this.selectedProductDetails?.product?.digital_physical == "digital"
        ? true
        : false;
    },
    headers: function () {
      let list = [
        createTableHeader("media", { mw: 47 }),
        createTableHeader("side", { mw: 40 }),
        createTableHeader("no", { mw: 60 }),
        createTableHeader("artist", {}),
        createTableHeader("title_column", {
          text: 'title',
        }),
        createTableHeader("isrc", {
          ta: "center",
          text: 'isrc',
          mw: 110,
        }),
        createTableHeader("bonus", {
          ta: "center",
          mw: 50,
        }),
        createTableHeader("licensor", {}),
        createTableHeader("time", { mw: 84 }),
        //  createTableHeader("edit", { text: false, mw: 30 }),
        createTableHeader("duplicate", {
          text: false,
          mw: 30,
        }),
        createTableHeader("options", { text: false, mw: 30 }),
      ];

      if(this.isDigital){
        console.log("::::::::",list)

        list.splice(6, 0, createTableHeader("digital_rights", { text:'digital rights'}));

        return list.filter(x=>x.value!='side');
      }

      return list;
    },
    list: function () {
      return this.selectedProductDetails.tracks || [];
    },
  },
  methods: {
    getConcatTitle: function (item) {
      if (item.version && item.version.length > 0) {
        return `${item["title"]} (${item["version"]})`;
      }

      return item["title"] || "";
    },

    onArtistClick: function (item) {
      console.log(item);
      this.$router.push({ path: "/main/catalog/tracks" });
    },
    onDropDownChange:function(name,e,item){
        console.log(e.value,name,item);
        const payload = {
            kVal:  item.track_id,
            name:  name,
            value: e.value
        }
      //   this.$emit("changed", {
      //   name,
      //   value,
      //   item,
      //   product_id: this.selectedProductDetails.product_id,
      // });
    },
    onTrackClick: function (item) {
      this.$router.push({
        name: tracksListLDTRoutes.names.tab,
        params: {
          track_id: item.track_id,
          tab: "overview",
        },
      });
    },
    onDuplicateTrack: function (item) {
      this.$emit("setDuplicateModalData", item);
    },
    onDeleteTrack: function (payload) {
      console.log("PPP", payload);
      this.$emit("delete", payload);
    },
    onTextInputBlur: function (event, name, item) {
      console.log("event", item);
      const value = event.value;

      this.$emit("changed", {
        name,
        value,
        item,
        product_id: this.selectedProductDetails.product_id,
      });
    },
    onContactNameClick: function (contact) {
      this.$emit("contact_selected", contact);
    },
    onMail: function (contact) {
      openMailWindow(`mailto: ${contact.email1}`);
    },
    addTrack: function () {
      this.$router.push({
        ...this.$route,
        query: {
          modal: "add_track",
          external_id: this.selectedProductDetails.product.product_id,
        },
      });
    },
    onDeleteRelatedContact: function (contact) {
      this.$emit("delete", contact);
    },
    onProductExclude: function (e, item) {
      console.log(e.target.checked, "e.target.selected");
      if (e.target.checked) {
        this.$emit("changed", {
          name: "bonus_track_flag",
          value: 1,
          item,
          product_id: this.selectedProductDetails.product_id,
        });
      }

      this.$emit("changed", {
        name: "bonus_track_flag",
        value: 0,
        item,
        product_id: this.selectedProductDetails.product_id,
      });
    },
    onRightMenuClick: function (menu) {
      console.log(menu);
      switch (menu) {
        case "copy_track": {
          this.$router.push({
            ...this.$route,
            query: {
              modal: "copy_track_modal",
              external_id: this.selectedProductDetails.product.product_id,
            },
          });
          break;
        }
        case "update_playtime": {
          ConfirmationService.create({
            subject:
              "Do you want to reset all playtime or only 00:00:00 playtimes? ",
            model: true,
            width: 500,
            results: [
              createConfirmResult({
                value: "only_zero",
                text: "Only Zero",
                classes: ["v1"],
              }),
              createConfirmResult({
                value: "all",
                text: "All",
                classes: ["v1"],
              }),
              createConfirmResult({
                value: "close",
              }),
            ],
            completed: (res) => {
              switch (res) {
                case "only_zero": {
                  const payload = {
                    action: "update_zero_playtime",
                    product_id: this.selectedProductDetails.product.product_id,
                  };
                  this.$emit("updatePlayTime", payload);
                  break;
                }
                case "all": {
                  const payload = {
                    action: "update_all_playtime",
                    product_id: this.selectedProductDetails.product.product_id,
                  };
                  this.$emit("updatePlayTime", payload);
                  break;
                }
                default: {
                }
              }
            },
          });

          break;
        }
      }
    },
    // MARK: Methods
  },
};
</script>

<style lang="scss">
.cmp-catalog-products-tracklisting {
  .dt-ntable {
    th.exclude {
      span {
        /* margin: 0px 8px; */
      }
    }
  }
  .dt-modal .dt-modal--options button:nth-last-child(3) {
    margin-right: 10px;
  }
}
</style>
